import { RouteView,PageView } from '@/layouts'
export const system =  {
    path: '/system',
    meta: { title: '系统管理', icon: 'setting', isMenuShow:true,permission:'sys'},
    component:PageView,
    children: [
        // {
        //     path: '/system/store',
        //     name: 'sysStore',
        //     redirect:'/system/store/list',
        //     component:PageView,
        //     meta: { title: '门店管理', keepAlive: false,isMenuShow:true,permission:'sys:store'},
        //     children:[
        //         {
        //             path: '/system/store/list',
        //             name: 'sysStoreList',
        //             component: () => import('../views/system/storeList.vue'),
        //             meta: { title: '门店列表', keepAlive: false,isMenuShow:false,permission:'sys:store'}
        //         },
        //         {
        //             path: '/system/store/edit/detail',
        //             name: 'sysStoreEdit',
        //             component: () => import('../views/system/storeEditDetail.vue'),
        //             meta: {title: '门店编辑', keepAlive: false, isMenuShow: false,permission:'sys:store:alter'},
        //         },
        //         {
        //             path: '/system/store/detail',
        //             name: 'sysStoreDetail',
        //             component: () => import('../views/system/storeDetail.vue'),
        //             meta: { title: '新增门店', keepAlive: false,isMenuShow:false,permission:'sys:store:add'},
        //         },
        //         {
        //             path: '/system/store/accountList',
        //             name: 'sysAccountList',
        //             component: () => import('../views/system/accountList.vue'),
        //             meta: { title: '账户明细', keepAlive: false,isMenuShow:false,permission:'sys:storeuser'}
        //         },
        //         {
        //             path: '/system/store/accountCreate',
        //             name: 'sysStoreAccountDetail',
        //             component: () => import('../views/system/storeAccountDetail.vue'),
        //             meta: { title: '新增账号', keepAlive: false,isMenuShow:true,permission:'sys:storeuser:add'},
        //         },
        //     ],
        // },
        {
            path: '/system/dealer',
            name: 'sysDealer',
            redirect:'/system/dealer/list',
            component:PageView,
            meta: { title: '经销商管理', keepAlive: false,isMenuShow:true,permission:'sys:dealer'},
            children:[
                {
                    path: '/system/dealer/list',
                    name: 'sysDealerList',
                    component: () => import('../views/system/dealerList.vue'),
                    meta: { title: '经销商列表', keepAlive: false,isMenuShow:false,permission:'sys:dealer'}
                },
            ],
        },

        {
            path: '/system/store/org',
            name: 'sysStoreOrg',
            redirect: '/system/store/org/list',
            component: PageView,
            meta: {title: '门店管辖区管理', keepAlive: false, isMenuShow: true,permission:'sys:area'},
            children: [
                {
                    path: '/system/store/org/list',
                    name: 'sysStoreOrgList',
                    component: () => import('../views/system/storePrecinct.vue'),
                    meta: {title: '门店管辖区列表', keepAlive: false, isMenuShow: false,permission:'sys:area'}
                },
            ],
        },
        {
            path: '/system/xny_group',
            name: 'sysXnyGroup',
            redirect:'/system/xny_group/list',
            component:PageView,
            meta: { title: '新能源工作组管理', keepAlive: false,isMenuShow:true,permission:'sys:officerole'},
            children:[
                {
                    path: '/system/xny_group/list',
                    name: 'sysXnyGroupList',
                    component: () => import('../views/system/xnyGroup.vue'),
                    meta: { title: '新能源工作组管理明细', keepAlive: false,isMenuShow:true,permission:'sys:officerole'},
                },
            ]
        },
        {
            path: '/system/store_group',
            name: 'sysStoreGroupList',
            component: () => import('../views/system/storeGroup.vue'),
            meta: { title: '门店工作组管理', keepAlive: false,isMenuShow:true,permission:'sys:storerole'},
        },
        {
            path: '/system/org',
            name: 'sysOrg',
            redirect:'/system/org/list',
            component:PageView,
            meta: { title: '新能源账号管理', keepAlive: false, isMenuShow:true,permission:'sys:officeuser'},
            children:[
                {
                    path: '/system/org/list',
                    name: 'sysOrgList',
                    component: () => import('../views/system/orgList.vue'),
                    meta: { title: '账号明细', keepAlive: false,isMenuShow:true,permission:'sys:officeuser'},
                },
                {
                    path: '/system/org/create',
                    name: 'sysOrgCreate',
                    component: () => import('../views/system/orgAccountAdd.vue'),
                    meta: { title: '新增账号', keepAlive: false,isMenuShow:true,permission:'sys:officeuser:add'},
                },
                {
                    path: '/system/org/edit',
                    name: 'sysOrgEdit',
                    component: () => import('../views/system/orgAccountDetail.vue'),
                    meta: { title: '编辑账号', keepAlive: false,isMenuShow:true,permission:'sys:officeuser:alter'},
                },
            ]
        },
    ]
}
